import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Creatives = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  RoleBasedRedirector: lazy(() => import('./components/RoleBasedRedirector.tsx')),
  Digital: {
    CreativesList: lazyNamed(() => import('./containers/Digital/containers/CreativesList/index.tsx'), 'CreativesList'),
    CreativeHistory: lazyNamed(
      () => import('./containers/Digital/containers/CreativesList/containers/CreativeHistory/index.tsx'),
      'CreativeHistory',
    ),
    CreativeForm: lazyNamed(() => import('./containers/Digital/containers/CreativePage.tsx'), 'CreativePage'),
    CreativeFormV2: lazyNamed(() => import('./containers/Digital/containers/CreativeFormV2/index.tsx'), 'CreativeFormV2'),
    BulkUploadNative: lazyNamed(() => import('./containers/Digital/containers/BulkUploadNative/index.tsx'), 'BulkUploadNative'),
    Providers: lazyNamed(() => import('./containers/Digital/components/Providers.tsx'), 'Providers'),
  },
  Print: {
    CreativesList: lazyNamed(() => import('./containers/Print/containers/CreativesList/index.tsx'), 'CreativesList'),
    CreativeForm: lazy(() => import('./containers/Print/containers/CreativeFormPage/index.tsx')),
  },
  AdServer: {
    CreativesList: lazyNamed(() => import('./containers/AdServer/containers/CreativesList/index.tsx'), 'CreativesList'),
    CreativeDetails: lazy(() => import('./containers/AdServer/containers/CreativeDetails/index.tsx')),
  },
  Templates: {
    TemplatesList: lazyNamed(() => import('./containers/Templates/index.ts'), 'TemplatesList'),
    TemplateForm: lazyNamed(() => import('./containers/Templates/index.ts'), 'TemplateForm'),
  },
};

export default Creatives;
